import React, { useContext, useEffect } from 'react';
import { Route, Redirect, useHistory } from 'react-router-dom';
import { AuthContext } from '../Auth';
import * as ROUTES from '../constants/routes';
import { split } from 'lodash';
import * as ORIGINAL_HREF from '../constants/originalHref';
import OT, { Publisher } from '@opentok/client';

const PrivateRoute = ({ component: RouteComponent, ...rest }) => {
	const { currentUser } = useContext(AuthContext);

	var starthref = window.location.href;
	var splitHref = starthref.split('?');

	if (splitHref.length > 1) {
		console.log('WINDOWS ORIGINAL HREF ' + splitHref[1]);
		ORIGINAL_HREF.originalHREF['splitHref'] = splitHref[1];
		//Object.freeze(ORIGINAL_HREF.originalHREF);
	}

	const history = useHistory();

	useEffect(() => {
		history.listen((location) => {
			// location is an object like window.location
		});
	}, [history]);

	return (
		<Route
			{...rest}
			render={(routeProps) =>
				!!currentUser ? (
					<RouteComponent {...routeProps} />
				) : (
					<Redirect to={ROUTES.SIGN_IN} />
				)
			}
		/>
	);
};

export default PrivateRoute;
